<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="模板管理"
      :visible.sync="visible"
      width="1000px"
      @close="handleClose"
      class="amazon_category_dialog component"
    >
      <div class="box">
        <div class="right">
          <div class="common-limit line-height-40">
            <div style="margin-top: 0;" class="form-body">
              <el-form
                ref="form"
                :model="queryParams"
                label-width="80px"
                size="small"
              >
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="模板名称：" prop="templateName">
                      <el-input
                        size="small"
                        v-model="queryParams.templateName"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="btn-bar-right">
                    <div style="float:right;">
                      <el-button type="primary" size="small" @click="loadData"
                        >搜索</el-button
                      >
                      <el-button size="small" @click="resetForm"
                        >重置</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div style="padding-bottom: 0px;" class="form-body">
            <div style="overflow:hidden;">
              <span style="float:left;">
                <el-button
                  type="primary"
                  size="small"
                  @click="handleShowEdit({})"
                  >新增</el-button
                >
              </span>
              <pagination
                v-show="total > 0"
                :total="total"
                :page.sync="queryParams.pageNum"
                :limit.sync="queryParams.pageSize"
                @pagination="loadData"
                :layout="'slot, total, sizes, prev, pager, next, jumper'"
              >
              </pagination>
            </div>
            <el-table
              @selection-change="handleSelectionChange"
              style="height:300px;overflow-y: auto;"
              :data="tableData"
            >
              <el-table-column
                type="selection"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                label="模板名称"
                prop="templateName"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.templateName }}
                </template>
              </el-table-column>

              <el-table-column prop="handel" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleShowEdit(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="deleteRow(scope.row)"
                    >删除</el-button
                  ><br />
                </template>
              </el-table-column>
            </el-table>
            <div style="overflow:hidden;">
              <div style="float:left;margin: 4px 0 0 0;">
                <el-button @click="handleBatchDeleteTerm" size="small"
                  >批量删除</el-button
                >
              </div>

              <pagination
                style="margin: 8px 0 0 0;float:right"
                class="bottom-sticky"
                v-show="total > 0"
                :total="total"
                :page.sync="queryParams.pageNum"
                :limit.sync="queryParams.pageSize"
                @pagination="loadData"
              />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" size="small"
          >关 闭</el-button
        >
        <el-button v-if="false" @click="handleClose" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="600px"
    >
      <el-form
        :model="editDialog.form"
        :rules="editDialog.rules"
        ref="advisoryForm"
        label-width="140px"
      >
        <el-form-item label="模板名称：" prop="templateName">
          <el-input
            size="small"
            style="width:400px"
            v-model="editDialog.form.templateName"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSkuList } from "@/api/template/template"
import { mapGetters } from "vuex"
import { getCategorySuggestion } from "@/api/order/lazada"
import draggable from "vuedraggable"
import Classification from "./classification"
import TreeSelect from "@/components/common/treeSelect"
import {
  getQuestionList,
  addQuestion,
  updateQuestion,
  deleteQuestion,
} from "@/api/sysSupport/question"
import {
  getTemplateList,
  editTemplate,
  addTemplate,
  removeTemplate,
} from "@/api/sysSupport/term"

import {
  addType,
  getTypeLlist,
  editType,
  deleteType,
} from "@/api/sysSupport/term"

export default {
  name: "TemplateManageDialog",
  components: { draggable, Classification, TreeSelect },
  data() {
    return {
      tables: [],
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      },
      setTree: [],
      classificationVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        templateName: "",
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      batchImportVisible: false,
      total: 0,
      tableData: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        form: {
          templateId: "",
          templateName: "",
        },
        fileList: [],
        rules: {
          templateName: [
            { required: true, message: "请输入模板名称", trigger: "blur" },
          ],
        },
      },

      keywordList: [],
      selectionList: [],
    }
  },
  watch: {
    visible: {
      handler() {},
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["user", "dictMap", "dictData"]),
  },
  model: {
    prop: "visible",
    event: "change",
  },
  mounted() {
    this.getTypeLlist()
    this.loadData()
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    shopId: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleSubmit() {
      this.$emit("change", false)
    },
    handleClose() {
      this.$emit("change", false)
    },
    handleBatchAddTerm() {
      if (this.selectionList.length == 0) {
        this.msgError("请选择模板")
        return
      }
      for (let selection of this.selectionList) {
        this.handleAddTerm(selection)
      }
    },
    handleBatchDeleteTerm() {
      if (this.selectionList.length == 0) {
        this.msgError("请选择模板")
        return
      }
      this.$confirm(
        `确认批量删除${this.selectionList.length}个模板吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        let templateIds = []
        for (let record of this.selectionList) {
          templateIds.push(record.templateId)
        }
        removeTemplate({ templateIds: templateIds.join(",") }).then(
          (response) => {
            if (response.code == "200") {
              this.$message.success("删除成功！")
              this.loadData()
            } else {
              this.$message.error("删除失败！")
            }
          }
        )
      })
    },
    handleSelectionChange(val) {
      let list = []
      val.forEach((item) => {
        list.push(item)
      })
      this.selectionList = list
    },
    handleShowTypeList() {
      this.classificationVisible = true
    },
    async getTypeLlist() {
      this.isLoading = true
      const { rows } = await getTypeLlist({})
      this.isLoading = false
      if (rows) {
        this.setTree = rows
      }
    },
    closeClassification() {
      this.classificationVisible = false
    },

    /** 查询问题列表 */
    showClassification() {
      this.classificationVisible = true
    },
    handleNodeClick(node) {
      if (node) {
        this.queryParams.typeId = node.typeId
      } else {
        this.queryParams.typeId = ""
      }
      this.loadData()
    },
    loadData() {
      this.startLoading()
      // if (this.queryParams.time) {
      //   this.queryParams.manageTimeBegin = this.queryParams.time[0]
      //   this.queryParams.manageTimeEnd = this.queryParams.time[1]
      // } else {
      //   this.queryParams.manageTimeBegin = undefined
      //   this.queryParams.manageTimeEnd = undefined
      // }
      let params = this._.clone(this.queryParams)
      // delete params["time"]
      getTemplateList(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },
    /**显示编辑页面 */
    handleShowEdit(row, isAdd) {
      this.editDialog.isAdd = isAdd ? isAdd : false
      if (row.templateId) {
        this.editDialog.form = Object.assign({}, row)
        this.editDialog.title = "编辑模板"
      } else {
        this.editDialog.form = {}
        this.editDialog.title = "新增模板"
      }
      this.editDialog.dialogVisible = true
    },
    handleAddTerm(row) {
      let isExist = false
      for (let record of this.keywordList) {
        if (record.term == row.term) {
          isExist = true
          break
        }
      }

      if (!isExist) {
        this.keywordList.push(row)
      }
    },
    handleRemoveTerm(index) {
      this.keywordList.splice(index, 1)
    },
    deleteRow(row) {
      this.$confirm(
        '是否确定删除<span style="color: red">' + row.templateName + "</span>?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(function() {
          return removeTemplate({ templateIds: row.templateId })
        })
        .then(() => {
          this.loadData()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    handleSave() {
      this.$refs["advisoryForm"].validate(async (valid) => {
        if (valid) {
          this.startLoading()
          let form = JSON.parse(JSON.stringify(this.editDialog.form))
          if (form.templateId) {
            editTemplate(form).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.endLoading()
                this.loadData()
              } else {
                this.endLoading()
                this.$message.error("修改失败")
              }
            })
          } else {
            form.sTitleTemplateTypes = [
              {
                name: "title",
                typeName: "我的核心词",
                termMin: "0",
                termMax: "1",
                content: "这里是我的核心词的位置(标题上保留的原内容)",
                stitleTemplateTypeTerms: [],
                isEdit: false,
              },
            ]
            addTemplate(form).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.endLoading()
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.endLoading()
                this.$message.error("新增失败")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 119px;
}
.avator {
}
.info {
  margin-left: 4px;
}
.amazon_category_dialog ::v-deep .el-dialog__footer {
  text-align: right;
}

.amazon_category_dialog ::v-deep .el-collapse-item__header {
  padding: 0px 8px;
  background-color: #f9f9f9;
}

.amazon_category_dialog ::v-deep .el-collapse-item__content {
  padding-bottom: 8px;
}

.text {
  text-align: center;
  margin: 24px 10px 15px 0;
  color: #909399;
}
.terms {
  margin: 0px 0 0 16px;
}
.add-button:hover {
  color: #4934b2;
}
.add-term-btn {
  border: 1px solid #ebeef5;
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 3px;
  margin-bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  margin-top: 12px;
}
.fa-plus {
  line-height: 31px;
  color: #4934b2;
}
.component .box {
  display: flex;
}
.component .box .group {
  border: 1px solid #ebeef5;
}
.component .box .right {
  width: 100%;
}
.group {
  width: 200px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
.mr-10px {
  margin-right: 10px;
}
.group .group_title {
  padding: 5px 15px;
  background: #fcfcfc;
  font-size: 13px;
  height: 33px;
  line-height: 33px;
  border-bottom: 1px solid #ebeef5;
}
.group .group_title .fa {
  position: relative;
  top: 10px;
  color: #333;
}

.c-pointer {
  cursor: pointer;
}
.f-r {
  float: right;
}

.keywords {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.keywords .el-textarea__inner {
  height: var(--height) !important;
  min-height: 32px !important;
}

.keywords .keyword {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-right: 10px;
  border: 1px solid #ebeef5;
  padding: 7px 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  line-height: 16px;
  cursor: pointer;
}

.keywords .keyword:hover {
  border: 1px solid #4934b2;
}

.keywords .keyword .fa-remove {
  cursor: pointer;
  color: #4934b2;
}

.keywords .keyword .fa-remove:hover {
  opacity: 0.8;
}

.keywords .btn {
  border: 1px solid #ebeef5;
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 3px;
  margin-bottom: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.keywords .btn .fa-plus {
  line-height: 31px;
  color: #4934b2;
}

.keywords .el-textarea__inner {
  height: 56px;
  width: 130px;
}
</style>
